import { faUpload } from '@fortawesome/pro-regular-svg-icons';
import { Button, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useState } from 'react';
import { usePublishRoomVersionMutation } from 'src/features/manage-room/manage-room.slice';
import { VersionControlActionsModal } from '../version-control-actions-modal';
import { StyledButtonIcon, StyledButtonText } from './publish-modal.styles';
export const VersionControlPublishModal = ({
  roomCode,
  isDraftModified
}: {
  roomCode: string;
  isDraftModified: boolean;
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [changeDescription, setChangeDescription] = useState('');
  const [publishRoomVersion] = usePublishRoomVersionMutation();
  const handleChangeInput = (content: string) => {
    setChangeDescription(content);
  };
  const handlePublishVersion = async () => {
    try {
      const description = changeDescription.trim() || 'Push changes from latest draft';
      await publishRoomVersion({
        roomCode,
        changeDescription: description
      }).unwrap();
      NotificationDispatch('success', 'Room changes have been successfully published.');
      setChangeDescription('');
    } catch {
      NotificationDispatch('error', 'Uh-oh. There was an error while publishing room changes. Please try again.');
    } finally {
      setOpenModal(false);
    }
  };
  const handleModalAction = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    handlePublishVersion();
  };
  return <>
      <Button color="add" onClick={() => setOpenModal(true)} disabled={!isDraftModified} data-sentry-element="Button" data-sentry-source-file="publish-modal.tsx">
        <StyledButtonIcon icon={faUpload} data-sentry-element="StyledButtonIcon" data-sentry-source-file="publish-modal.tsx" />
        <StyledButtonText data-sentry-element="StyledButtonText" data-sentry-source-file="publish-modal.tsx">Save new version</StyledButtonText>
      </Button>

      <VersionControlActionsModal open={openModal} openChange={setOpenModal} closeButtonText="Cancel and go back" titleText="Push your changes?" actionButtonText="Push changes" message="Are you sure you want to publish these changes? This will impact existing content." warningBoxText="Please review and confirm all updates you've made, as they may impact existing content. Pay special attention to any modifications in tasks, settings, virtual machines, or other critical components." handleModalAction={handleModalAction} changesTextInput changesTextInputValue={changeDescription} changesTextInputOnChange={handleChangeInput} data-sentry-element="VersionControlActionsModal" data-sentry-source-file="publish-modal.tsx" />
    </>;
};